import { render, staticRenderFns } from "./OrgAddressSearch.vue?vue&type=template&id=3cf4b47c&"
import script from "./OrgAddressSearch.vue?vue&type=script&lang=ts&"
export * from "./OrgAddressSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports